<!-- 客户报表详情 -->
<template>
  <div class="comContent body-box">
    <div class="body-title">
      <div class="body-title-left">{{name}}</div>
      <div class="body-title-right"><el-button size="small" @click="goBack">返回</el-button></div>
    </div>
    <div class="body-tools">
      <div class="body-tools-left">
        <el-form ref="formTool" :model="formTool" :inline="true">
          <el-form-item label="" prop="">
            <el-input v-model="formTool.shopName" size="small" placeholder="请输入客户名称" clearable />
          </el-form-item>
          <el-form-item label="首次下单时间" prop="">
            <el-date-picker v-model="formTool.firstTime" size="small" type="daterange" value-format="yyyy-MM-dd" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="最后下单时间" prop="">
            <el-date-picker v-model="formTool.endTime" size="small" type="daterange" value-format="yyyy-MM-dd" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="最后访问时间" prop="">
            <el-date-picker v-model="formTool.lastVistTime" size="small" type="daterange" value-format="yyyy-MM-dd" clearable range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="" prop="phone">
            <MyButton type="primary" text="查询" @click="goSearch" />
            <el-button size="small" @click="formToolReset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="body-tools-right">
        <!-- <MyButton type="primary" text="返回" @click="goBack" /> -->
      </div>
    </div>
    <div class="body-table">
      <MyTable :table-data="tableData"
        max-height="calc(100% - 44px)"
        :index="false"
        :selection="false"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
        @sort-change="sortChange"
        @handleSelectionChange="currentChange">
        <template slot="type" slot-scope="scope">
          <span>{{ scope.row.type=='ios'?'苹果系统':'安卓系统' }}</span>
        </template>
        <template slot="tools" slot-scope="scope">
          <div style="display:flex">
            <el-link type="primary" :underline="false" size="small" @click="goLink(scope.row)">查看详情</el-link>
          </div>
        </template>
      </MyTable>
    </div>
  </div>
</template>

<script>

import MyButton from '@/components/myButton'
import MyTable from '@/components/myTable';
import { queryGoodsSalesEcharts } from "@/api/statistics";
export default {
  name:'ReportCustomerDetail',
  components: { MyButton, MyTable },
  data() {
    return {
      id:'',
      name:'',
      formTool: {
        shopName:'',
        firstTime:'',
        endTime:'',
        lastVistTime:'',
      },
      tableData: [],
      tableOption: [
        { label: '商户名称', prop: 'payee_shop_name', minWidth: '140px' },
        { label: '运营人员及联系方式', prop: 'payee_concat_name', minWidth: '140px' },
        { label: '订单量', prop: 'order_cnt', minWidth: '90px',sortable:'custom' },
        { label: '商品销量', prop: 'qty', minWidth: '90px',sortable:'custom' },
        { label: '采购额(元)', prop: 'amount', minWidth: '110px',sortable:'custom' },
        { label: '客单价(元)', prop: 'avg_order_amount', minWidth: '110px',sortable:'custom' },
        { label: '首次下单时间',  prop: 'shp_first_ord_time', width: '150px',sortable:'custom' },
        { label: '最后下单时间', prop: 'shp_last_ord_time',sortable:'custom', width: '150px' },
        { label: '最后访问时间', prop: 'last_visit_time',sortable:'custom', width: '150px' },
        { label: '操作', prop: 'tools', slot: true, width: '80px' }
      ],
      sortStatus:'up',
      sortType:'1',// 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
      page: { total: 10, current: 1, size: 10 },
    };
  },
  computed: {},
  watch: {},
  created() {
    let query = this.$route.query;
    if(query.id && query.name){
      this.id = query.id;
      this.name = query.name;
      this.initData();
    }else{
      this.goBack();
    }
  },
  mounted() {

  },
  methods: {
    goLink(el){
      let url = `/reportCustomer/reportCustomer-reportDetailMore?id=${el.pay_shop_id}&name=${el.pay_shop_name}&shopId=${el.payee_shop_id}&shopName=${el.payee_shop_name}`;
      // let url = type==1?'/reportCustomer/reportCustomer-reportDetail':'/reportCustomer/reportCustomer-reportDetailMore?id=2133&cid=23423'
      this.$router.push(url);
    },
    goSearch(){
      this.sortStatus = 'up';
      // this.sortType = '1';
      this.initData();
    },
    sortChange(el){
      const { column, prop, order } = el; // order释义：descending:降,ascending:升,为空时代表不选中
      console.log(column, prop, order)
      // 执行条件搜索操作
      let propNames = {
        order_cnt: { label: '订单量', value: '1' },
        qty: { label: '商品销量', value: '2' },
        amount: { label: '采购额', value: '3' },
        avg_order_amount: { label: '客单价', value: '4' },
        shp_first_ord_time: { label: '首次下单时间', value: '5' },
        shp_last_ord_time: { label: '最后下单时间', value: '6' },
        last_visit_time: { label: '最后访问时间', value: '7' },
      }
      // 执行条件搜索操作
      this.sortStatus = order == 'descending'?'down':'up';
      // sortType:'1',// 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
      this.sortType = (order && propNames[prop]) ? propNames[prop].value : '1';
      this.initData();
    },
    formToolReset () {
      this.formTool = {
        shopName:'',
        firstTime:'',
        endTime:'',
        lastVistTime:'',
      }
      // this.$refs.formTool.resetFields()
      this.initData();
    },
    currentChange(){},
    initData(){
      this.page.current = 1;
      this.getList();
    },
    getList(){
      // console.log('getList-重新加载数据')
      let obj = this.getParams(this.sortStatus);
      let totalObj = this.getParams('total');
      queryGoodsSalesEcharts(obj).then(list=>{
        this.tableData = list || [];
      })
      queryGoodsSalesEcharts(totalObj).then(list=>{
        // 获取总条数
        let total = 0;
        if(list && list.length>0){
          total = parseInt(list[0].cnt);
        }
        this.page.total = total;
      })
    },
    getParams(status = 'up'){
      const { current, size } = this.page;
      const { shopName, firstTime, endTime, lastVistTime } = this.formTool;

      let firstSTime = '';
      let firstETime = '';
      if(firstTime && firstTime.length>0){
        firstSTime = firstTime[0].replaceAll('-', '');
        firstETime = firstTime[1].replaceAll('-', '');
      }
      let EndSTime = '';
      let EndETime = '';
      if(endTime && endTime.length>0){
        EndSTime = endTime[0].replaceAll('-', '');
        EndETime = endTime[1].replaceAll('-', '');
      }
      let vistSTime = '';
      let vistETime = '';
      if(lastVistTime && lastVistTime.length>0){
        vistSTime = lastVistTime[0].replaceAll('-', '');
        vistETime = lastVistTime[1].replaceAll('-', '');
      }
      let types = {
        up: 92, down:93, total:94, // export:57
      }
      let type = types[status];
      let params = [
        this.id,// 客户ID"1606205771220635650"
        // erp_id || '',erp_id || '',// ERPID
        shopName || '',shopName || '', // 客户名称
        // pay_concat_phone || '',pay_concat_phone || '', // 客户电话
        // priviceCode,priviceCode, // 省编码
        // cityCode,cityCode, // 市编码
        // areaCode,areaCode, // 区编码
        // pay_shop_type_name || '',pay_shop_type_name || '', // 客户类型编码
        firstSTime,firstSTime, // 首次下单时间(开始时间)
        firstETime,firstETime, // 首次下单时间(结束时间)
        EndSTime,EndSTime, // 最后下单时间(开始时间)
        EndETime,EndETime, // 最后下单时间(结束时间)
        vistSTime,vistSTime, // 最后访问时间(开始时间)
        vistETime,vistETime, // 最后访问时间(结束时间)
      ]
      let paramsMore = [
        this.sortType, // 排序字段: 订单量 1,商品销量 2,采购额（元） 3,客单价（元） 4,首次下单时间 5,最后下单时间 6,最后访问时间 7
        size, // 每页行数
        (current - 1)*size, // 第几行开始
      ]
      return { type, params: (status=='up' || status == 'down') ? [ ...params, ...paramsMore ] : params}
    },
    goBack () {
      // console.log('go back');
      this.$router.push("/reportCustomer/reportCustomer-reportList");

      // this.$router.go(-1)：后退+刷新；
      // this.$router.go(0)：刷新；
      // this.$router.go(1) ：前进
      // this.$router.back(); //:后退
      // this.$router.back(0) 刷新；
      // this.$router.back(1)：前进
    },
  },
  // beforeCreate() { },
  // beforeMount() { },
  // beforeUpdate() { },
  // updated() { },
  // beforeDestroy() { },
  // destroyed() { },
  // activated() { },
}
</script>
<style lang='scss' scoped>
.body{
  &-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    border-bottom: 1px solid #eee;
    &-left{
      width: calc(100% - 90px);
      line-height: 1;
      font-size: 26px;
      font-weight: 600;
      color: #000;
    }
    &-right{
      width: 90px;
      text-align: right;
    }
  }
  &-tools{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 16px;
    &-left{
      width: calc(100% - 90px);
    }
    &-right{
      width: 90px;
      text-align: right;
    }
    ::v-deep .el-form{
      &-item{
        margin-bottom: 6px !important;
      }
    }
  }
  &-table{
    height: calc(100% - 130px);
  }
}
</style>
